import { computed, ComputedRef } from "vue";
import {
  CmsImage,
  CmsPersonalPathwayStepData,
  CmsRichText,
  CmsTeamPathwayStepData,
} from "../services/cms/cms-type-definitions";

interface FinalStepContent {
  text: ComputedRef<CmsRichText>;
  image: ComputedRef<CmsImage>;
  lottieSrc: ComputedRef<string>;
  lottieShouldFadeOut: boolean;
  buttonText: ComputedRef<string>;
  buttonLink: undefined;
  isCompleteButton: boolean;
  showCloseButton: boolean;
}

export function useFinalPathwayStepSlice(
  pathwayStep: CmsTeamPathwayStepData | CmsPersonalPathwayStepData,
): FinalStepContent {
  const text = computed(() => pathwayStep.final_slide_text);
  const image = computed(() => pathwayStep.final_slide_image);
  const lottieSrc = computed(() => pathwayStep.final_slide_lottie_file.url);
  const lottieShouldFadeOut = false;
  const buttonText = computed(() => pathwayStep.complete_button_text || "Complete Step");
  const buttonLink = undefined;
  const isCompleteButton = true;
  const showCloseButton = true;

  return {
    text,
    image,
    lottieSrc,
    lottieShouldFadeOut,
    buttonText,
    buttonLink,
    isCompleteButton,
    showCloseButton,
  };
}

export default useFinalPathwayStepSlice;
